import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import { toast } from 'react-toastify';

const Footer = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [claiming, setClaiming] = useState(false);

  const handleSecretClick = async () => {
    if (!user) {
      toast.info('Log in to discover secrets...');
      navigate('/login');
      return;
    }

    if (claiming) return;
    setClaiming(true);

    try {
      const res = await api.post('/badges/claim-secret/diamond-in-the-rough');
      
      if (res.data.success) {
        toast.success(res.data.message, {
          autoClose: 5000,
          icon: '💎'
        });
      } else if (res.data.already_claimed) {
        toast.info(res.data.message, { icon: '💎' });
      }
    } catch (error) {
      if (error.response?.status === 404) {
        toast.error('Secret not found... keep looking!');
      } else {
        console.error('Secret badge error:', error);
      }
    } finally {
      setClaiming(false);
    }
  };

  return (
    <footer className="bg-black border-t border-[#1a1a1a] mt-auto">
      {/* Gold accent line */}
      <div className="h-1 bg-gradient-to-r from-transparent via-[#C5A52A] to-transparent opacity-30" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {/* Network Partners */}
          <div>
            <h3 className="font-display text-sm text-white tracking-widest mb-4">
              NETWORK PARTNERS
            </h3>
            <div className="space-y-2">
              <a
                href="https://accountability.works"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-display text-sm text-gray-500 hover:text-[#C5A52A] tracking-wider transition-colors"
              >
                ACCOUNTABILITY.WORKS
              </a>
              <div className="border-t border-gray-800 my-2" />
              <a
                href="https://canshare.news"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-display text-sm text-gray-500 hover:text-white tracking-wider transition-colors"
              >
                CAN SHARE NEWS
              </a>
              <div className="border-t border-gray-800 my-2" />
              <a
                href="https://showusyourregina.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-display text-sm text-gray-500 hover:text-white tracking-wider transition-colors"
              >
                SHOWUSYOURREGINA.CA
              </a>
              <div className="border-t border-gray-800 my-2" />
              <Link
                to="/nonprofits"
                className="block font-display text-sm text-red-500 hover:text-red-400 tracking-wider transition-colors"
              >
                NON-PROFITS
              </Link>
            </div>
          </div>

          {/* Secret Badge Icon - Center */}
          <div className="flex justify-center">
            <button 
              onClick={handleSecretClick}
              disabled={claiming}
              className="flex flex-col items-center gap-2 group focus:outline-none"
              title="You found something..."
            >
              <div className={`w-16 h-16 bg-[#C5A52A]/20 border border-[#C5A52A]/40 rounded-full flex items-center justify-center group-hover:bg-[#C5A52A]/30 group-hover:scale-110 transition-all overflow-hidden ${claiming ? 'animate-pulse' : ''}`}>
                <img 
                  src="/footer-icon.png" 
                  alt="YQR" 
                  className="w-12 h-12 object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span className="text-[#C5A52A] font-bold text-lg hidden">YQR</span>
              </div>
            </button>
          </div>

          {/* Governance */}
          <div className="text-right">
            <h3 className="font-display text-sm text-white tracking-widest mb-4">
              GOVERNANCE
            </h3>
            <div className="space-y-2">
              <Link
                to="/advertise"
                className="block font-display text-sm text-gray-500 hover:text-[#C5A52A] tracking-wider transition-colors"
              >
                ADVERTISE WITH US
              </Link>
              <div className="border-t border-gray-800 my-2" />
              <Link
                to="/realtors"
                className="block font-display text-sm text-gray-500 hover:text-[#C5A52A] tracking-wider transition-colors"
              >
                REALTORS — OWN YOUR WARD
              </Link>
              <div className="border-t border-gray-800 my-2" />
              <Link
                to="/terms"
                className="block font-display text-sm text-gray-500 hover:text-white tracking-wider transition-colors"
              >
                TERMS OF SERVICE
              </Link>
              <div className="border-t border-gray-800 my-2" />
              <Link
                to="/takedown"
                className="block font-display text-sm text-red-500 hover:text-red-400 tracking-wider transition-colors"
              >
                TAKEDOWN PORTAL
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-6 border-t border-gray-900 text-center">
          <p className="font-mono text-xs text-gray-600 tracking-wider">
            © 2026 CYQR.CA // CIVIC ENGAGEMENT PLATFORM
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
